import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';

export type SubCategoryCreateData = { id: string };

export type SubCategoryCreateResponse = SubCategoryCreateData

export interface SubCategoryCreateBody {
  text: string;
  categoryId: string;
  subCategoryId: string;
  articleId: string;
  fileIds: string[];
}

export const subCategoryCreate = (payload: SubCategoryCreateBody): Action<SubCategoryCreateBody> => ({
  type: actions.subCategoryCreateTrigger.toString(),
  payload,
});

export const subCategoryCreateClear = (): Action => ({
  type: actions.subCategoryCreateClear.toString(),
});

export const subCategoryCreateErrorClear = (): Action => ({
  type: actions.subCategoryCreateErrorReset?.toString(),
});

export function* subCategoryCreateRequestSaga({ payload }: Action<SubCategoryCreateBody>) {
  ({ payload })
  yield put({
    type: actions.subCategoryCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.subCategoryCreateError.toString(),
      payload: {
        message: 'SubCategoryCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}sub-categories`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<SubCategoryCreateData, SubCategoryCreateResponse>(
    response,
    actions.subCategoryCreateSuccess.toString(),
    actions.subCategoryCreateError.toString(),
    false,
    (subCategoryCreateData) => subCategoryCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.subCategoryCreateTrigger.toString(),
    defaultProcessingSaga(
      subCategoryCreateRequestSaga,
      {
        error: actions.subCategoryCreateError.toString(),
        locationCancel: actions.subCategoryCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.subCategoryCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.subCategoryCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.subCategoryCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.subCategoryCreateErrorReset.toString(),
    });
  });
}
